export default function getUrlParameter(name) {
    if (typeof window === 'undefined' || !window.location) {
        return null;
    }

    const queryParamRegex = new RegExp('[?&]' + name + '=([^&]*)', 'gi');
    const matchedParams = queryParamRegex.exec(window.location.href);

    return matchedParams && matchedParams.length > 0 ? matchedParams[1] : null;
}